export const SCRAPERS_FETCHED = 'SCRAPERS_FETCHED';
export const SCRAPER_ADD = 'SCRAPER_ADD';
